import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from '../../ui/Button';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../../../common/SafeIcon';
import { HeroIllustration } from './HeroIllustration';

export const HeroSection = () => {
  return (
    <section className="relative pt-32 pb-20 lg:pt-40 lg:pb-32 overflow-hidden bg-meetoi-offwhite">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        
        {/* Top Label */}
        <div className="flex justify-center mb-8">
          <div className="inline-flex items-center px-4 py-1.5 rounded-full bg-white border border-meetoi-aqua/50 shadow-sm">
            <span className="w-2 h-2 rounded-full bg-meetoi-coral mr-2 animate-pulse"></span>
            <span className="text-[10px] font-bold tracking-widest uppercase text-meetoi-navy font-manrope">
              Relationship Intelligence Platform
            </span>
          </div>
        </div>

        {/* Headlines */}
        <div className="text-center max-w-4xl mx-auto">
          <h1 className="font-sora text-5xl md:text-6xl lg:text-7xl font-bold text-meetoi-navy tracking-tight mb-6 leading-[1.1]">
            Turn every introduction into a <span className="text-meetoi-blue">relationship.</span>
          </h1>
          <p className="font-manrope text-lg md:text-xl text-meetoi-text font-medium max-w-2xl mx-auto mb-10 leading-relaxed">
            Meetoi helps you share your profile instantly, capture meaningful details, and follow up at the right time—so your connections grow stronger over time.
          </p>
          
          {/* Actions */}
          <div className="flex flex-col sm:flex-row justify-center items-center gap-4 mb-12">
            <Link to="/register" className="w-full sm:w-auto">
              <Button size="lg" className="w-full sm:w-auto bg-meetoi-navy hover:bg-meetoi-navy/90 text-white rounded-xl px-8 py-4 text-base font-manrope font-semibold border-0 shadow-lg shadow-meetoi-navy/10">
                Create your Meetoi card
              </Button>
            </Link>
            <Link to="/#how-it-works" className="w-full sm:w-auto">
              <Button variant="secondary" size="lg" className="w-full sm:w-auto bg-white hover:bg-meetoi-offwhite text-meetoi-navy border-meetoi-aqua/50 rounded-xl px-8 py-4 text-base font-manrope font-semibold">
                <SafeIcon icon={FiIcons.FiPlay} className="mr-2" /> See how it works
              </Button>
            </Link>
          </div>

          {/* Social Proof */}
          <div className="flex items-center justify-center gap-4">
            <div className="flex -space-x-3">
              <div className="w-8 h-8 rounded-full bg-meetoi-blue border-2 border-meetoi-offwhite flex items-center justify-center text-white text-xs"><SafeIcon icon={FiIcons.FiUser} /></div>
              <div className="w-8 h-8 rounded-full bg-meetoi-navy border-2 border-meetoi-offwhite flex items-center justify-center text-white text-xs"><SafeIcon icon={FiIcons.FiUser} /></div>
              <div className="w-8 h-8 rounded-full bg-meetoi-coral border-2 border-meetoi-offwhite flex items-center justify-center text-white text-xs"><SafeIcon icon={FiIcons.FiUser} /></div>
            </div>
            <p className="font-manrope text-xs font-semibold text-meetoi-text text-left leading-tight">
              Join professionals building<br/>stronger relationships
            </p>
          </div>
        </div>

        {/* Graphic Area */}
        <HeroIllustration />

      </div>
    </section>
  );
};